import { axios } from '@ben/api/axios';
import { optionalNumber } from '@ben/shared/utils/zod';
import * as Sentry from '@sentry/react';
import { z } from 'zod';
import { employerConfigurationValuesSchema } from '../schema/employer-configuration-values';

export const eccUiConfigSchema = z.object({
  canViewSystemNotifications: z.boolean(),
  canViewBenefitWizard: z.boolean(),
  canViewCompensationCard: z.boolean(),
  canViewContributionCard: z.boolean(),
  canViewRemoteActivities: z.boolean().optional(),
  canEmployeeViewIntercomMessenger: z.boolean(),
  canEmployeeViewIntercomSurveys: z.boolean(),
  canAdminViewIntercom: z.boolean(),
  canViewProgrammes: z.boolean(),
  canViewMoneyManagement: z.boolean(),
  canViewInvoices: z.boolean(),
  canViewCompanyWallet: z.boolean(),
  canCreateBenefit: z.boolean(),
  canCreateAllowanceRequest: z.boolean(),
  employer: optionalNumber,
  enableHrisIntegrationConfig: z.boolean(),
  enableNewEccEnrolmentUi2023: z.boolean().optional(),
  id: z.number(),
  helpDeskUrl: z.string(),
  values: employerConfigurationValuesSchema,
  isWhitelabel: z.boolean(),
  adminHelpDeskUrl: z.string(),
  canEditBenefitSelections: z.boolean(),
  useCustomBenefitSorting: z.boolean(),
  hasRewardsAndRecognition: z.boolean(),
  showNmwReport: z.boolean().optional(),
  showAeReport: z.boolean().optional(),
  showContributionHolidaysReport: z.boolean().optional(),
  showDocumentSigningReport: z.boolean().optional(),
  canViewCampaigns: z.boolean().optional(),
  canViewResourcesHub: z.boolean().optional(),
  resourcesHubName: z.string().nullable().optional(),
  canUseAchDirectDebit: z.boolean().optional(),
  contactTimezone: z.string().optional(),
});

export type ECCUiConfig = z.infer<typeof eccUiConfigSchema>;

export enum ECCFeatureFlag {
  NEW_ECC_ENROLMENT_UI = 'enableNewEccEnrolmentUi2023',
}

export const getEccUiConfig = async (): Promise<ECCUiConfig> => {
  const response = await axios.get('ecc/v1.0/ui-config/');

  try {
    return eccUiConfigSchema.parse(response.data);
  } catch (error) {
    Sentry.captureException(error);
  }
  return response.data;
};

export default getEccUiConfig;
